export const historyUsageMock = [
  {
    formattedDate: "1 декабря 2025 г. 17:28",
    duration: 32402,
    type: "Интернет",
    callingNumber: "79010754224",
    dialedNumber: "undefined",
    traffic: 27.75,
    unit: "Кб",
    amount: "0",
    balance: 37666,
  },
  {
    formattedDate: "1 декабря 2025 г. 8:28",
    duration: 32401,
    type: "Интернет",
    callingNumber: "79010754224",
    dialedNumber: "undefined",
    traffic: 27.16,
    unit: "Кб",
    amount: "0",
    balance: 37666,
  },
  {
    formattedDate: "30 ноября 2025 г. 23:28",
    duration: 32401,
    type: "Интернет",
    callingNumber: "79010754224",
    dialedNumber: "undefined",
    traffic: 27.06,
    unit: "Кб",
    amount: "0",
    balance: 37666,
  },
  {
    formattedDate: "30 ноября 2025 г. 14:28",
    duration: 32402,
    type: "Интернет",
    callingNumber: "79010754224",
    dialedNumber: "undefined",
    traffic: 27.24,
    unit: "Кб",
    amount: "0",
    balance: 37666,
  },
  {
    formattedDate: "30 ноября 2025 г. 5:28",
    duration: 32402,
    type: "Интернет",
    callingNumber: "79010754224",
    dialedNumber: "undefined",
    traffic: 27.3,
    unit: "Кб",
    amount: "0",
    balance: 37666,
  },
  {
    formattedDate: "29 ноября 2025 г. 20:27",
    duration: 32401,
    type: "Интернет",
    callingNumber: "79010754224",
    dialedNumber: "undefined",
    traffic: 27.32,
    unit: "Кб",
    amount: "0",
    balance: 37666,
  },
  {
    formattedDate: "29 ноября 2025 г. 11:27",
    duration: 32401,
    type: "Интернет",
    callingNumber: "79010754224",
    dialedNumber: "undefined",
    traffic: 34.72,
    unit: "Кб",
    amount: "0",
    balance: 37666,
  },
  {
    formattedDate: "29 ноября 2025 г. 2:27",
    duration: 32402,
    type: "Интернет",
    callingNumber: "79010754224",
    dialedNumber: "undefined",
    traffic: 27.42,
    unit: "Кб",
    amount: "0",
    balance: 37666,
  },
  {
    formattedDate: "28 ноября 2025 г. 17:27",
    duration: 32401,
    type: "Интернет",
    callingNumber: "79010754224",
    dialedNumber: "undefined",
    traffic: 27.21,
    unit: "Кб",
    amount: "0",
    balance: 37666,
  },
  {
    formattedDate: "28 ноября 2025 г. 8:27",
    duration: 32417,
    type: "Интернет",
    callingNumber: "79010754224",
    dialedNumber: "undefined",
    traffic: 19.09,
    unit: "Кб",
    amount: "0",
    balance: 37666,
  },
  {
    formattedDate: "27 ноября 2025 г. 22:08",
    duration: 18981,
    type: "Интернет",
    callingNumber: "79010754224",
    dialedNumber: "undefined",
    traffic: 27,
    unit: "Кб",
    amount: "0",
    balance: 37666,
  },
  {
    formattedDate: "27 ноября 2025 г. 13:08",
    duration: 32402,
    type: "Интернет",
    callingNumber: "79010754224",
    dialedNumber: "undefined",
    traffic: 20.24,
    unit: "Кб",
    amount: "0",
    balance: 37666,
  },
  {
    formattedDate: "27 ноября 2025 г. 13:08",
    duration: 120,
    type: "Голосовая связь международная",
    callingNumber: "79010754224",
    dialedNumber: "441622766766",
    traffic: 0,
    unit: "Сек",
    amount: "120",
    balance: 37666,
  },
  {
    formattedDate: "27 ноября 2025 г. 4:10",
    duration: 32266,
    type: "Интернет",
    callingNumber: "79010754224",
    dialedNumber: "undefined",
    traffic: 13.74,
    unit: "Кб",
    amount: "0",
    balance: 37786,
  },
  {
    formattedDate: "26 ноября 2025 г. 19:10",
    duration: 32402,
    type: "Интернет",
    callingNumber: "79010754224",
    dialedNumber: "undefined",
    traffic: 27.46,
    unit: "Кб",
    amount: "0",
    balance: 37786,
  },
  {
    formattedDate: "26 ноября 2025 г. 10:12",
    duration: 0,
    type: "SMS",
    callingNumber: "0",
    dialedNumber: "79085543013",
    traffic: 0,
    unit: "SMS",
    amount: "0",
    balance: 37786,
  },
  {
    formattedDate: "26 ноября 2025 г. 10:11",
    duration: 0,
    type: "SMS",
    callingNumber: "0",
    dialedNumber: "79085543013",
    traffic: 0,
    unit: "SMS",
    amount: "0",
    balance: 37786,
  },
  {
    formattedDate: "26 ноября 2025 г. 10:10",
    duration: 32403,
    type: "Интернет",
    callingNumber: "79010754224",
    dialedNumber: "undefined",
    traffic: 13.8,
    unit: "Кб",
    amount: "0",
    balance: 37786,
  },
  {
    formattedDate: "26 ноября 2025 г. 10:10",
    duration: 120,
    type: "Голосовая связь международная",
    callingNumber: "79010754224",
    dialedNumber: "441622766766",
    traffic: 0,
    unit: "Сек",
    amount: "120",
    balance: 37786,
  },
  {
    formattedDate: "26 ноября 2025 г. 7:49",
    duration: 8431,
    type: "Интернет",
    callingNumber: "79010754224",
    dialedNumber: "undefined",
    traffic: 1416.38,
    unit: "Кб",
    amount: "0",
    balance: 37906,
  },
  {
    formattedDate: "25 ноября 2025 г. 22:49",
    duration: 32401,
    type: "Интернет",
    callingNumber: "79010754224",
    dialedNumber: "undefined",
    traffic: 2961.54,
    unit: "Кб",
    amount: "0",
    balance: 38906,
  },
  {
    formattedDate: "25 ноября 2025 г. 14:39",
    duration: 0,
    type: "SMS",
    callingNumber: "0",
    dialedNumber: "79085543013",
    traffic: 0,
    unit: "SMS",
    amount: "0",
    balance: 39006,
  },
  {
    formattedDate: "25 ноября 2025 г. 14:38",
    duration: 60,
    type: "Голосовая связь",
    callingNumber: "79010754224",
    dialedNumber: "79807099562",
    traffic: 0,
    unit: "Сек",
    amount: "0",
    balance: 39006,
  },
  {
    formattedDate: "25 ноября 2025 г. 14:18",
    duration: 30659,
    type: "Интернет",
    callingNumber: "79010754224",
    dialedNumber: "undefined",
    traffic: 675.78,
    unit: "Кб",
    amount: "0",
    balance: 38906,
  },
  {
    formattedDate: "3 ноября 2025 г. 6:54",
    duration: 0,
    type: "Голосовая связь",
    callingNumber: "4954809630",
    dialedNumber: "79010754224",
    traffic: 0,
    unit: "Сек",
    amount: "0",
    balance: 0,
  },
  {
    formattedDate: "21 октября 2025 г. 1:02",
    duration: 0,
    type: "SMS",
    callingNumber: "0",
    dialedNumber: "79085543013",
    traffic: 0,
    unit: "SMS",
    amount: "0",
    balance: 87705,
  },
  {
    formattedDate: "17 октября 2025 г. 19:43",
    duration: 31101,
    type: "Интернет",
    callingNumber: "79010758924",
    dialedNumber: "undefined",
    traffic: 3.81,
    unit: "Кб",
    amount: "0",
    balance: 93805,
  },
  {
    formattedDate: "24 сентября 2025 г. 19:21",
    duration: 11047,
    type: "Интернет",
    callingNumber: "79010758924",
    dialedNumber: "undefined",
    traffic: 28.96,
    unit: "Кб",
    amount: "0",
    balance: 5655,
  },
  {
    formattedDate: "24 сентября 2025 г. 18:41",
    duration: 2401,
    type: "Интернет",
    callingNumber: "79010758924",
    dialedNumber: "undefined",
    traffic: 17.79,
    unit: "Кб",
    amount: "0",
    balance: 5655,
  },
  {
    formattedDate: "24 сентября 2025 г. 10:01",
    duration: 31205,
    type: "Интернет",
    callingNumber: "79010758924",
    dialedNumber: "undefined",
    traffic: 33.3,
    unit: "Кб",
    amount: "0",
    balance: 5655,
  },
  {
    formattedDate: "24 сентября 2025 г. 1:23",
    duration: 31098,
    type: "Интернет",
    callingNumber: "79010758924",
    dialedNumber: "undefined",
    traffic: 26.32,
    unit: "Кб",
    amount: "0",
    balance: 5655,
  },
  {
    formattedDate: "23 сентября 2025 г. 20:29",
    duration: 12373,
    type: "Интернет",
    callingNumber: "79010758924",
    dialedNumber: "undefined",
    traffic: 19.37,
    unit: "Кб",
    amount: "0",
    balance: 5655,
  },
  {
    formattedDate: "23 сентября 2025 г. 19:39",
    duration: 2974,
    type: "Интернет",
    callingNumber: "79010758924",
    dialedNumber: "undefined",
    traffic: 17.78,
    unit: "Кб",
    amount: "0",
    balance: 5655,
  },
  {
    formattedDate: "23 сентября 2025 г. 10:31",
    duration: 32883,
    type: "Интернет",
    callingNumber: "79010758924",
    dialedNumber: "undefined",
    traffic: 20.32,
    unit: "Кб",
    amount: "0",
    balance: 5655,
  },
  {
    formattedDate: "23 сентября 2025 г. 1:31",
    duration: 32397,
    type: "Интернет",
    callingNumber: "79010758924",
    dialedNumber: "undefined",
    traffic: 25.55,
    unit: "Кб",
    amount: "0",
    balance: 5655,
  },
  {
    formattedDate: "23 сентября 2025 г. 1:20",
    duration: 668,
    type: "Интернет",
    callingNumber: "79010758924",
    dialedNumber: "undefined",
    traffic: 20.29,
    unit: "Кб",
    amount: "0",
    balance: 5655,
  },
  {
    formattedDate: "22 сентября 2025 г. 16:18",
    duration: 32482,
    type: "Интернет",
    callingNumber: "79010758924",
    dialedNumber: "undefined",
    traffic: 13.74,
    unit: "Кб",
    amount: "0",
    balance: 5655,
  },
  {
    formattedDate: "22 сентября 2025 г. 6:56",
    duration: 33746,
    type: "Интернет",
    callingNumber: "79010758924",
    dialedNumber: "undefined",
    traffic: 33.44,
    unit: "Кб",
    amount: "0",
    balance: 5655,
  },
  {
    formattedDate: "21 сентября 2025 г. 22:19",
    duration: 31001,
    type: "Интернет",
    callingNumber: "79010758924",
    dialedNumber: "undefined",
    traffic: 24.3,
    unit: "Кб",
    amount: "0",
    balance: 5655,
  },
  {
    formattedDate: "21 сентября 2025 г. 22:09",
    duration: 593,
    type: "Интернет",
    callingNumber: "79010758924",
    dialedNumber: "undefined",
    traffic: 22.32,
    unit: "Кб",
    amount: "0",
    balance: 5655,
  },
  {
    formattedDate: "21 сентября 2025 г. 12:46",
    duration: 33790,
    type: "Интернет",
    callingNumber: "79010758924",
    dialedNumber: "undefined",
    traffic: 27.34,
    unit: "Кб",
    amount: "0",
    balance: 5655,
  },
  {
    formattedDate: "21 сентября 2025 г. 4:16",
    duration: 30601,
    type: "Интернет",
    callingNumber: "79010758924",
    dialedNumber: "undefined",
    traffic: 27.97,
    unit: "Кб",
    amount: "0",
    balance: 5655,
  },
  {
    formattedDate: "20 сентября 2025 г. 19:20",
    duration: 32172,
    type: "Интернет",
    callingNumber: "79010758924",
    dialedNumber: "undefined",
    traffic: 25.23,
    unit: "Кб",
    amount: "0",
    balance: 5655,
  },
  {
    formattedDate: "20 сентября 2025 г. 19:07",
    duration: 783,
    type: "Интернет",
    callingNumber: "79010758924",
    dialedNumber: "undefined",
    traffic: 24.1,
    unit: "Кб",
    amount: "0",
    balance: 5655,
  },
  {
    formattedDate: "20 сентября 2025 г. 10:23",
    duration: 31437,
    type: "Интернет",
    callingNumber: "79010758924",
    dialedNumber: "undefined",
    traffic: 19.81,
    unit: "Кб",
    amount: "0",
    balance: 5655,
  },
  {
    formattedDate: "20 сентября 2025 г. 1:34",
    duration: 31752,
    type: "Интернет",
    callingNumber: "79010758924",
    dialedNumber: "undefined",
    traffic: 26.92,
    unit: "Кб",
    amount: "0",
    balance: 5655,
  },
  {
    formattedDate: "19 сентября 2025 г. 16:40",
    duration: 32049,
    type: "Интернет",
    callingNumber: "79010758924",
    dialedNumber: "undefined",
    traffic: 27.57,
    unit: "Кб",
    amount: "0",
    balance: 5655,
  },
];
